import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Input } from '@driftt/tide-core-legacy'

import './style'

class NewRuleConfirmation extends Component {

  static contextTypes = {
    app: PropTypes.object,
    router: PropTypes.object
  }

  componentDidMount() {
    // force page validation
    this.props.updateTitle(this.props.rule.data.item.name)
  }

  updateTitle = (event) => {
    this.props.updateTitle(event.target.value)
  }

  render() {
    return (
      <div className="rules-choice">
        <header className="publish-header">
          <h1>Ready to publish your Rule?</h1>
          <small>We recommend giving your rule a name so you can reference it later.</small>
        </header>

        <div className="rule-publish-content drift-form">
          <Input
            className="rule-name-input"
            autoFocus
            type="text"
            placeholder="Name your rule"
            size="large"
            description="*required"
            value={this.props.rule.data.item.name}
            onChange={this.updateTitle}/>
        </div>
      </div>
    )
  }
}

export default NewRuleConfirmation



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/NewRuleConfirmation/index.js